import { getTelemetryEventQueueLength } from '@ms/yammer-telemetry-store';

import { getLogEventInputWithContext } from './getReportLogEventsInput';
import { createDeliveryLifecycleInfoEvent } from './reportDeliveryLifecycleInfo';
import { reportLogEventWithKeepalive } from './reportTelemetryEventsToServer';

const getQueuedLogEventCount = () =>
  getTelemetryEventQueueLength('Error') +
  getTelemetryEventQueueLength('Info') +
  getTelemetryEventQueueLength('Performance');

type ReportLogQueueForPageHide = () => void;
export const reportLogQueueForPageHide: ReportLogQueueForPageHide = () => {
  const resultCount = getQueuedLogEventCount();
  if (resultCount === 0) {
    return;
  }

  reportLogEventWithKeepalive(
    getLogEventInputWithContext(
      createDeliveryLifecycleInfoEvent({
        eventInputType: 'Log',
        outcome: 'pagehide_queue_observed',
        resultCount,
        skipAuthentication: true,
      })
    ).event
  );
};
